import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import BadgeCard from './BadgeCard';
import BadgeModal from './BadgeModal';
export default class BadgesPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "badges", []);
    _defineProperty(this, "categories", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadData();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(app.translator.trans('fof-badges.forum.badges_title'));
  }
  async loadData() {
    this.loading = true;
    m.redraw();
    try {
      const _await$Promise$all = await Promise.all([app.store.find('badges'), app.store.find('badge-categories')]),
        _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
        badges = _await$Promise$all2[0],
        categories = _await$Promise$all2[1];

      // Filter to ensure only valid models are stored
      this.badges = (Array.isArray(badges) ? badges : []).filter(b => b && typeof b.id === 'function' && b.isVisible());
      this.categories = (Array.isArray(categories) ? categories : []).filter(c => c && typeof c.id === 'function' && c.isEnabled());

      // Check if specific badge is requested via URL query param
      const params = new URLSearchParams(window.location.search);
      const badgeId = params.get('badge');
      if (badgeId) {
        this.openBadgeById(badgeId);
      }
    } catch (error) {
      console.error('Failed to load badges:', error);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  openBadgeById(id) {
    const badge = this.badges.find(b => b.id() === id);
    if (badge) {
      setTimeout(() => this.showBadgeModal(badge), 100);
    }
  }
  view() {
    return m(PageStructure, {
      className: "BadgesPage",
      hero: () => m("header", {
        className: "Hero BadgesHero"
      }, m("div", {
        className: "container"
      }, m("div", {
        className: "containerNarrow"
      }, m("h1", {
        className: "Hero-title"
      }, m("i", {
        "aria-hidden": "true",
        className: "icon fas fa-award"
      }), " ", app.translator.trans('fof-badges.forum.badges_title'))))),
      sidebar: () => m(IndexSidebar, null)
    }, this.loading ? m(LoadingIndicator, null) : this.renderContent());
  }
  renderContent() {
    if (this.badges.length === 0) {
      return m("div", {
        className: "BadgesPage-empty"
      }, m("i", {
        className: "fas fa-award BadgesPage-empty-icon"
      }), m("p", null, app.translator.trans('fof-badges.forum.no_badges')));
    }
    return this.renderBadgesList();
  }
  renderBadgesList() {
    const uncategorized = this.badges.filter(b => !b.category());
    const byCategory = this.categories.filter(cat => cat && typeof cat.id === 'function') // Ensure valid model
    .map(cat => ({
      category: cat,
      badges: this.badges.filter(b => {
        const category = b.category();
        return category && typeof category.id === 'function' && category.id() === cat.id();
      })
    })).filter(g => g.badges.length > 0);
    const canViewUserBadges = app.session.user && app.forum.attribute('canViewUserBadges');
    return m("div", {
      className: "BadgesList"
    }, canViewUserBadges && m("div", {
      className: "BadgesList-header"
    }, m(Link, {
      className: "Button",
      href: app.route('user.badges', {
        username: app.session.user.slug()
      })
    }, m("i", {
      className: "fas fa-user icon"
    }), app.translator.trans('fof-badges.forum.my_badges'))), byCategory.map(group => m("section", {
      className: "BadgesList-category",
      key: group.category.id()
    }, m("h2", {
      className: "BadgesList-categoryTitle"
    }, group.category.name()), group.category.description() && m("p", {
      className: "BadgesList-categoryDescription"
    }, group.category.description()), m("div", {
      className: "BadgesList-grid"
    }, group.badges.map(badge => m(BadgeCard, {
      key: badge.id(),
      badge: badge,
      onclick: () => this.showBadgeModal(badge),
      isOwned: badge.isEarned()
    }))))), uncategorized.length > 0 && m("section", {
      className: "BadgesList-category BadgesList-category--uncategorized"
    }, m("h2", {
      className: "BadgesList-categoryTitle"
    }, app.translator.trans('fof-badges.forum.other_badges')), m("div", {
      className: "BadgesList-grid"
    }, uncategorized.map(badge => m(BadgeCard, {
      key: badge.id(),
      badge: badge,
      onclick: () => this.showBadgeModal(badge),
      isOwned: badge.isEarned()
    })))));
  }
  showBadgeModal(badge) {
    const baseUrl = app.route('badges');
    const newUrl = "".concat(baseUrl, "?badge=").concat(badge.id());
    window.history.pushState(null, '', newUrl);
    app.modal.show(BadgeModal, {
      badge,
      onhide: () => {
        window.history.pushState(null, '', baseUrl);
      }
    });
  }
}
flarum.reg.add('fof-badges', 'forum/components/BadgesPage', BadgesPage);